import type { ActivityRange } from '~/types/game-pass'

export function getEventStatus(
  visibleRange: ActivityRange,
  now: number,
): 'pending' | 'active' | 'ended' {
  const lower = new Date(visibleRange.lower).getTime()
  const upper = new Date(visibleRange.upper).getTime()

  const afterLower = visibleRange.exclude_lower ? now > lower : now >= lower
  const beforeUpper = visibleRange.exclude_upper ? now < upper : now <= upper

  if (!afterLower) return 'pending'
  if (!beforeUpper) return 'ended'
  return 'active'
}
